<template>

  <div class="d-flex flex-column fill-height overflow-y-auto" style="position:absolute;width:100%;height:100%;">
    <v-virtual-scroll v-if="filteredJobs.length" :items="filteredJobs" item-height="84" bench="10" class="mt-4">
      <template #default="{item}">
        <JobBlock :job="item" @prioritiseIntent="prioritiseIntent" @rightClick="e=>$emit('rightClick', { job: item, e })" />
      </template>
    </v-virtual-scroll>
    <p v-else>
      <NoPrioritiesBlock @prioritiseIntent="prioritiseIntent" />
    </p>
    </div>
    
</template>

<style lang="scss" scoped>
.selected{
  background-color: lightblue;
}
</style>

<script>
import { mapGetters,  mapActions } from 'vuex';
import JobBlock from './JobBlock.vue';
import NoPrioritiesBlock from './NoPrioritiesBlock.vue';
//import LoadingBlock from './LoadingBlock.vue';
//import Sortable from 'sortablejs'

export default {
  name: 'AutoPriorities',
  components: {
    JobBlock, NoPrioritiesBlock
  },
  props: {
    jobs: { type: Array, required: true },
    queue: { type: Array, required: true },
  },
  data(){ return {
    loading: false,
    virtualItemHeight: 28,
    sortable: null,
    selected: null,
    contextMenu: {
      item: null,
      x: null,
      y: null,
    }
  }},
  computed:{
    ...mapGetters("AUTH", ["USER"]),

    filteredJobs(){
      return this.queue.map(xid => this.jobs.find(j => j.xid == xid));
    },

  },
  watch: {
  },

  methods: {
    ...mapActions("UI", ["SET_TITLE", "CONFIRM", "NAVIGATE"]),
    ...mapActions("API", ["API"]),

    clickJob(e, job){
      if(e.ctrlKey)
        this.openNewTab(job);
      else
        this.selected = this.selected == job.xid ? null : job.xid;
    },

    rightClickJob(e, job){
      this.contextMenu = { ...this.contextMenu,
        item: job,
        x: e.clientX, y: e.clientY
      };
      e.preventDefault();
    },

    prioritiseIntent(e){
      this.$emit('prioritiseIntent', e);
    },


  },
  mounted(){
  }
}
</script>
